import { InvalidPlaybackQueueSnapshotError, PLAYBACK_QUEUE_CHUNK_SIZE, } from '../ports/playback-event-store.js';
export function chunkIndexOf(seq) {
    return Math.floor(seq / PLAYBACK_QUEUE_CHUNK_SIZE);
}
/** First and last chunk holding headSeq to nextSeq - 1. last < first when the queue is empty. */
export function chunkRange(headSeq, nextSeq) {
    const first = chunkIndexOf(headSeq);
    return { first, last: nextSeq > headSeq ? chunkIndexOf(nextSeq - 1) : first - 1 };
}
/** How many events chunk `index` holds for this head and next sequence number. */
export function expectedChunkLength(index, headSeq, nextSeq) {
    const start = Math.max(index * PLAYBACK_QUEUE_CHUNK_SIZE, headSeq);
    const end = Math.min((index + 1) * PLAYBACK_QUEUE_CHUNK_SIZE, nextSeq);
    return Math.max(0, end - start);
}
export function isValidQueueMeta(value) {
    const m = value;
    return (!!m &&
        m.version === 2 &&
        typeof m.queueId === 'string' &&
        Number.isSafeInteger(m.droppedEvents) &&
        m.droppedEvents >= 0 &&
        Number.isSafeInteger(m.acknowledgedDroppedEvents) &&
        m.acknowledgedDroppedEvents >= 0 &&
        m.acknowledgedDroppedEvents <= m.droppedEvents &&
        Number.isSafeInteger(m.headSeq) &&
        m.headSeq >= 0 &&
        Number.isSafeInteger(m.nextSeq) &&
        m.nextSeq >= m.headSeq);
}
/**
 * Builds the loaded queue from its meta and chunks. A missing or wrong-sized chunk means the
 * stored queue can't be trusted: InvalidPlaybackQueueSnapshotError, its events count as dropped.
 */
export function assembleQueueState(meta, chunkAt) {
    if (!isValidQueueMeta(meta)) {
        throw new InvalidPlaybackQueueSnapshotError('Invalid playback queue meta');
    }
    const { first, last } = chunkRange(meta.headSeq, meta.nextSeq);
    const events = [];
    for (let index = first; index <= last; index += 1) {
        const chunk = chunkAt(index);
        if (!Array.isArray(chunk) ||
            chunk.length !== expectedChunkLength(index, meta.headSeq, meta.nextSeq)) {
            throw new InvalidPlaybackQueueSnapshotError('Playback queue chunk missing or wrong size', meta.nextSeq - meta.headSeq);
        }
        for (const event of chunk)
            events.push(event);
    }
    return { ...meta, events };
}
//# sourceMappingURL=playback-queue-chunks.js.map